// routes/adminRoutes.js
import { lazy } from 'react';

// Lazy load the Admin pages
const AdminDashboard = lazy(() => import('../pages/admin/AdminDashboard'));
const AdminSettings = lazy(() => import('../pages/admin/AdminSettings'));

export const adminRoutes = [
  { path: '/admin/dashboard', element: <AdminDashboard /> },
  { path: '/admin/settings', element: <AdminSettings /> },
];